var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"versions"},[_c('CurrVersions'),_c('h1',[_vm._v("Versions")]),_c('div',{staticClass:"table-wrapper loader-container"},[_c('vue-good-table',{attrs:{"columns":[
        {
          label: 'Version',
          field: 'version1',
          sortFn: this.sortVersion
        },
        {
          label: 'Compile Date',
          field: 'compileDate',
          formatFn: _vm.formatDateTime
        },
        {
          label: 'Alpha Date',
          field: 'alphaDate',
          formatFn: _vm.formatDateTime
        },
        {
          label: 'Beta Date',
          field: 'betaDate',
          formatFn: _vm.formatDateTime
        },
        {
          label: 'Release Date',
          field: 'releaseDate',
          formatFn: _vm.formatDateTime
        },
        {
          label: 'Stable Date',
          field: 'stableDate',
          formatFn: _vm.formatDateTime
        },
        {
          label: 'Release Notes',
          field: 'releaseNotes'
        }
      ],"rows":_vm.versions},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(
            props.column.field == 'alphaDate' &&
              !props.row.alphaDate &&
              _vm.sortVersion(props.row.version1, _vm.currentVersions.alphaVersion) ==
                1
          )?_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.setVersionAlpha(props.row.version1)}}},[_vm._v(" Set ")]):(
            props.column.field == 'betaDate' &&
              !props.row.betaDate &&
              _vm.sortVersion(props.row.version1, _vm.currentVersions.betaVersion) ==
                1
          )?_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.setVersionBeta(props.row.version1)}}},[_vm._v(" Set ")]):(
            props.column.field == 'releaseDate' &&
              !props.row.releaseDate &&
              _vm.sortVersion(
                props.row.version1,
                _vm.currentVersions.releaseVersion
              ) == 1
          )?_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.setVersionRelease(props.row.version1)}}},[_vm._v(" Set ")]):(
            props.column.field == 'stableDate' &&
              !props.row.stableDate &&
              _vm.sortVersion(
                props.row.version1,
                _vm.currentVersions.stableVersion
              ) == 1
          )?_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.setVersionStable(props.row.version1)}}},[_vm._v(" Set ")]):(props.column.field == 'releaseNotes')?_c('span',[_c('pre',[_vm._v(_vm._s(_vm.formatReleaseNotes(props.row.releaseNotes)))])]):_c('span',[_vm._v(" "+_vm._s(props.formattedRow[props.column.field])+" ")])]}}])}),_c('Loader',{attrs:{"loading":_vm.loadingVersions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }